import { handleForbiddenError } from "@portal/helpers/handleForbiddenError";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { IBuyFundOrderRequest } from "@portal/types/api/IBuyFundOrderRequest";
import { ISubmitOrderFundRequest, IUseSubmitOrderFund } from "./types";
import { IOrderResponse } from "@portal/types/api/IOrderResponse";
import useFundList from "../useFundList";

const useSubmitOrderFund: IUseSubmitOrderFund = () => {
  const { allFunds } = useFundList();

  const submitFundOrders = async (req: ISubmitOrderFundRequest) => {
    for (const reqFund of req.funds) {
      const fund = allFunds?.find(f => f.isin === reqFund.isin);
      if (!fund) {
        throw Error(RobotTextResources.primary.ERROR_AGREEMENT);
      }
      await submitFundOrder({
        portfolioId: req.portfolioId,
        instrumentId: fund.instrumentId,
        amount: reqFund.amount,
        useLedgerForCoverageControl: false,
        cashAccount: req.cashAccount,
        isSavingRobot: req.isSavingRobot,
        advisorCarriedOut: req.advisorCarriedOut,
        advisorName: req.advisorName,
      } as IBuyFundOrderRequest);
    }
  };

  const submitFundOrder = async (req: IBuyFundOrderRequest) => {
    const url = "/api/funds/buy";

    const response = await fetch(url, {
      method: "POST",
      headers: [
        ["accepts", "application/json"],
        ["Content-Type", "application/json"],
      ],
      body: JSON.stringify(req),
    });

    if (!response.ok) {
      const handledForbiddenError = await handleForbiddenError(response);
      throw Error(handledForbiddenError ?? RobotTextResources.primary.ERROR_AGREEMENT);
    }

    const order = (await response.json()) as IOrderResponse;
    return order;
  };

  return {
    submitFundOrders,
    submitFundOrder,
  };
};

export default useSubmitOrderFund;
